// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"51383ec2","787":"13e42567"}[chunkId] + ".chunk.js";
};